/* The 15% mask sale's "Limited time" / "Ends Saturday" / "Ends tomorrow" / "Last day" (snippets/sa-sale-ends.liquid),
   counted again in the browser because Shopify can serve a cached page from an earlier day. Days count in US Pacific
   time, where the discount ends at midnight. */
(function () {
  'use strict';
  const DAY = 86400000;
  // Calendar days left before the end (0 on the last day): the end is a Pacific midnight.
  const daysLeft = (end, now = Date.now()) => Math.ceil((end - now) / DAY) - 1;
  const phase = days => (days > 6 ? 'limited' : days > 1 ? 'endsDay' : days === 1 ? 'tomorrow' : 'last');
  function text(element, now) {
    const data = element.dataset;
    const end = Date.parse(data.end);
    if (!Number.isFinite(end) || now >= end) return null;
    const step = phase(daysLeft(end, now));
    if (data.kind === 'note') return step === 'limited' ? data.noteLimited : `${data.notePrefix} · ${data[step]}`;
    return data[step];
  }
  function run(now = Date.now()) {
    document.querySelectorAll('[data-sa-sale-ends]').forEach(element => {
      const value = text(element, now);
      if (value && element.textContent !== value) element.textContent = value;
    });
  }
  window.saSaleEnds = {daysLeft, phase, text, run};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(), {once: true});
  else run();
})();
